class Background {
	constructor() {
		this.dom = { items: document.querySelectorAll(".lpg_bg__item") };
		//console.log(this.dom.items);

		if (this.dom.items.length < 1) {
			return;
		}
		// écart entre les trucs

		this.init();
	}

	init() {
		this.delta = 200;

		this.rotateValue = [0, 90];
		this.leftValue = [[0, 30], [70, 100]];
		this.copyItemsInOrderToHaveEnoughItems();
	}

	copyItemsInOrderToHaveEnoughItems() {
		let h = document.body.scrollHeight;
		let nb_items = Math.ceil(h / this.delta);

		let nb_items_before_copy = this.dom.items.length;

		let factor = Math.ceil((nb_items - nb_items_before_copy) / nb_items_before_copy);
		const parent = document.getElementById("js-lpg_bg");
		for (var i = 0; i < factor; i++) {
			this.dom.items.forEach(el => {
				var cln = el.cloneNode(true);

				// Append the cloned <li> element to <ul> with id="myList1"
				parent.appendChild(cln);
				//this.displayPrettyPictos(el);
			});
		}

		this.dom.items = document.querySelectorAll(".lpg_bg__item");

		this.displayPrettyPictos(this.dom.items);
	}

	getRandomArbitrary(min, max) {
		return Math.random() * (max - min) + min;
	}

	displayPrettyPictos(items) {
		items.forEach((el, i) => {
			this.offset = 95 / this.dom.items.length;

			let top = this.getRandomArbitrary(this.offset * i - this.offset, this.offset * i + this.offset);
			if (top > document.body.scrollHeight) {
				//el.remove();
				//continue;
				top = Math.ceil(top - 10);
			}

			let left = this.leftValue[Math.floor(Math.random() * this.leftValue.length)];

			el.style.top = top + "%";
			el.style.left = this.getRandomArbitrary(left[0], left[1]) + "%";
			el.style.opacity = "1";
			el.style.transform = "rotate(" + this.rotateValue[Math.floor(Math.random() * this.rotateValue.length)] + "deg)";
			el.getElementsByTagName("img")[0].style.width = this.getRandomArbitrary(50, 100) + "%";
			//el.style.transition = "opacity 0.5s";
		});
	}
}
